import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';
import download from 'downloadjs';

export const SCHEDULE_EXPORT_REQUEST = 'SCHEDULE_EXPORT_REQUEST';
export const SCHEDULE_EXPORT_SUCCESS = 'SCHEDULE_EXPORT_SUCCESS';
export const SCHEDULE_EXPORT_FAILURE = 'SCHEDULE_EXPORT_FAILURE';

/**
 * Downloads the full schedule snapshot as a JSON file.
 *
 * @param {string} competitionId
 */
export const exportSchedule = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_EXPORT_REQUEST, competitionId });

    return axios(
      apiRequestOptions(apiPath.SCHEDULE.EXPORT, null, { params: { id: competitionId }, isBlob: true })
    )
      .then(transformHttpResponse)
      .then(response => {
        const contentType  = response.headers['content-type'] || 'application/json';
        const disposition  = response.headers['content-disposition'] || '';
        const match        = disposition.match(/filename="?([^";\s]+)"?/);
        const filename     = match ? match[1] : `schedule-${competitionId}.json`;

        download(response.data, filename, contentType);
        dispatch({ type: SCHEDULE_EXPORT_SUCCESS, competitionId });
      })
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_EXPORT_FAILURE, competitionId, error });
      });
  };
};
